import { handleActions } from "redux-actions";

import { PAYMENTS_MANAGEMENT } from "constants/action-types";
import { TransactionAggregate } from "records/payments";
import moment from "moment";
interface IError {
    message: string;
    request: any;
    status: number;
    xhr: any;
}

interface IMeta {
    next?: string;
    previous?: string;
    aggregateData?: TransactionAggregate;
}

interface IState {
    result: string[];
    isFetching: boolean;
    error: boolean;
    errorObject: IError | undefined;
    meta?: IMeta;
    date?: moment.Moment;
}

const initialState = {
    result: [],
    isFetching: false,
    error: false,
    errorObject: undefined,
    meta: {},
    date: undefined,
};

interface IFetchPayload {
    currencyCode: string;
    date: moment.Moment;
    direction?: "next" | "previous";
}

const transactionsReducer = handleActions<IState, any>(
    {
        [PAYMENTS_MANAGEMENT.TRANSACTIONS.FETCH.START]: (state: IState, action): IState => {
            const { payload }: { payload?: IFetchPayload } = action;

            const updatedState = {
                ...state,
                isFetching: true,
                error: false,
                date: payload.date,
            };

            if (!payload.direction || (state.date && !state.date.isSame(payload.date, "day"))) {
                // we've changed days or otherwise are making the first call, so clear cache
                updatedState.result = [];
            }

            return {
                ...updatedState,
            };
        },
        [PAYMENTS_MANAGEMENT.TRANSACTIONS.FETCH.COMPLETED]: (state: IState, response): IState => {
            const { payload, error, meta } = response as any;

            if (error) {
                return {
                    ...state,
                    result: [],
                    isFetching: false,
                    error,
                    errorObject: payload,
                };
            }

            if (meta && meta.aggregateData) {
                meta.aggregateData = new TransactionAggregate(meta.aggregateData);
            }

            return {
                ...state,
                result: state.result.concat(payload),
                isFetching: false,
                error,
                meta,
            };
        },
    },
    initialState
);
export type ITransactionsState = IState;

export default transactionsReducer;
